import {createContext} from '@lit-labs/context';
import type {Nullable} from '@gl/lit/types/general.js';

export type AudienceDatasetIds = {
  id: number;
  dataset_id: number;
  dataset_group_id: number;
  name: string;
  size: number;
  realtime?: {
    available: boolean;
    reason: string;
  };
};

export const AudienceContext =
  createContext<Nullable<AudienceDatasetIds>>('audience-context');
